
(function(){
  // ---------- Carrousels ----------
  function carousel(track,prev,next,onChange){
    const items=[...track.children];
    const step=()=>items.length>1?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth;
    const idx=()=>Math.round(track.scrollLeft/step());
    const go=i=>{const n=items.length;i=(i+n)%n;track.scrollTo({left:items[i].offsetLeft-items[0].offsetLeft})};
    prev&&(prev.onclick=()=>go(idx()-1));
    next&&(next.onclick=()=>{const end=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;go(end?0:idx()+1)});
    track.addEventListener('scroll',()=>requestAnimationFrame(()=>onChange&&onChange(Math.min(idx(),items.length-1))));
    return {go,items};
  }
  // Vidéo unique
  (function(){
    const inp=document.getElementById('ovInput');if(!inp)return;
    const slot=inp.closest('.vslot'),v=slot.querySelector('video'),snd=document.getElementById('ovSound');
    inp.addEventListener('change',()=>{const f=inp.files&&inp.files[0];if(!f)return;v.src=URL.createObjectURL(f);slot.classList.add('has');snd.hidden=false;v.play().catch(()=>{})});
    snd.onclick=()=>{v.muted=!v.muted;snd.textContent=v.muted?'🔇':'🔊';snd.setAttribute('aria-label',v.muted?'Activer le son':'Couper le son')};
    v.addEventListener('click',()=>{v.paused?v.play():v.pause()});
    if('IntersectionObserver' in window){new IntersectionObserver(([e])=>{if(e.isIntersecting&&!matchMedia('(prefers-reduced-motion: reduce)').matches)v.play().catch(()=>{});else v.pause()},{threshold:.4}).observe(v)}
  })();

  // ---------- Packs ----------
  const prices=['59,90 €','89,85 €','129,90 €','219,90 €'];
  const saves=['Vous économisez 10,00 €','Vous économisez 49,95 €','Vous économisez 79,80 €','Vous économisez 199,50 €'];
    function upd(){const v=+document.querySelector('input[name=b]:checked').value;document.getElementById('atcPrice').textContent=prices[v];document.getElementById('stickyPrice').textContent=prices[v];document.getElementById('saveMsg').textContent=saves[v]}
  document.getElementById('bundles').addEventListener('change',upd);upd();
  const CAP={0:{name:'3,8 L',p:[59.90,89.85,129.90,219.90],o:[69.90,139.80,209.70,419.40]},
             1:{name:'6 L',p:[69.90,99.90,139.90,239.90],o:[79.90,159.80,239.70,479.40]}};
  const base=['1 kit','2 kits','3 kits','Pack famille (6 kits)'];
  const VID={0:['50614261416075','50614261448843','50614261481611','50614261514379'],1:['50614261547147','50614261579915','50614261612683','50614261645451']};
  if(window.PURE_VARIANTS){const caps=['3,8 L','6 L'];window.PURE_VARIANTS.forEach(v=>{const c=caps.indexOf(v.option1),k=base.indexOf(v.option2);if(c>-1&&k>-1)VID[c][k]=String(v.id)})}
  let curCap=0;
  const fmt=n=>n.toFixed(2).replace('.',',')+' €';
  const cards=[...document.querySelectorAll('#bundles .pk')];
  function setCap(c){
    curCap=c;const d=CAP[c];
    document.querySelectorAll('.cap').forEach(b=>{const on=b.dataset.cap==c;b.classList.toggle('on',on);b.setAttribute('aria-checked',on)});
    cards.forEach((k,i)=>{k.querySelector('.pk-p').textContent=fmt(d.p[i]);k.querySelector('.pk-o').textContent=fmt(d.o[i])});
    d.p.forEach((v,i)=>{prices[i]=fmt(v);nums[i]=v;saves[i]='Vous économisez '+fmt(d.o[i]-v);labels[i]=d.name+' · '+base[i]});
    upd();
  }
  document.querySelectorAll('.cap').forEach(b=>b.addEventListener('click',()=>setCap(+b.dataset.cap)));
  const nums=[59.90,89.85,129.90,219.90],labels=['1 kit','2 kits','3 kits','Pack famille (6 kits)'];
  setCap(0);
  function add(){const v=+document.querySelector('input[name=b]:checked').value;window.pureAdd&&window.pureAdd('PURE-01 · '+labels[v],nums[v],VID[curCap][v])}
  document.getElementById('atc').onclick=add;document.getElementById('atc2').onclick=add;
  const st=document.getElementById('sticky'),atc=document.getElementById('atc');
  if('IntersectionObserver' in window){let a=false,f=false;const u=()=>st.classList.toggle('show',a&&!f&&scrollY>250);addEventListener('scroll',u,{passive:true});new IntersectionObserver(([e])=>{a=!e.isIntersecting;u()}).observe(atc);const ft=document.getElementById('footer');if(ft)new IntersectionObserver(([e])=>{f=e.isIntersecting;u()}).observe(ft)}


})();


(function(){
  const t=document.getElementById('gTrack');if(!t)return;
  const n=t.children.length,th=[...document.getElementById('gThumbs').children],c=document.getElementById('gCount');
  const idx=()=>Math.round(t.scrollLeft/Math.max(t.clientWidth,1));
  const go=i=>{i=(i+n)%n;t.scrollTo({left:i*t.clientWidth})};
  const upd=()=>{const i=Math.min(idx(),n-1);th.forEach((b,j)=>b.classList.toggle('on',j===i));c.textContent=(i+1)+' / '+n};
  document.getElementById('gPrev').onclick=()=>go(idx()-1);
  document.getElementById('gNext').onclick=()=>go(idx()+1);
  th.forEach((b,j)=>b.onclick=()=>go(j));
  t.addEventListener('scroll',()=>requestAnimationFrame(upd));
  t.addEventListener('keydown',e=>{if(e.key==='ArrowRight')go(idx()+1);if(e.key==='ArrowLeft')go(idx()-1)});
})();


(function(){
  const b=document.getElementById('rvMore');if(!b)return;
  b.onclick=()=>{const h=[...document.querySelectorAll('#rvGrid .rv[hidden]')];h.slice(0,6).forEach(e=>e.hidden=false);if(h.length<=6)b.parentNode.hidden=true;};
})();

addEventListener('load',()=>setTimeout(()=>document.querySelectorAll('.g-slide img[loading=lazy]').forEach(i=>i.loading='eager'),1500));

